import {defineStore} from "pinia";

export const useWishlistStore = defineStore("wishlist", {
  state: () => ({
    capsuleAll: {
      shopProductList: []
    },
    capsuleCustom: [],
  }),
  getters: {
    getterCapsuleAll(state) {
      return state.capsuleAll
    },
    getterCapsuleCustom(state) {
      return state.capsuleCustom
    },
  },
  actions: {
    updateCapsuleAll(capsuleAll) {
      this.capsuleAll = capsuleAll
    },
    updateCapsuleCustom(capsuleCustom) {
      this.capsuleCustom = capsuleCustom
    },
  },
  persist: {
    paths: []
  }
})
